///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-category.ts"/>


module Meevo.Components.Controls.SmartMover {


    import DP005ProductCategory = Meevo.Plugins.Reports.DP005ProductCategory;
    import DP005ProductManufecturer = Meevo.Plugins.Reports.DP005ProductManufecturer;
    import IReportDP005Product = Meevo.Plugins.Reports.IReportDP005Product;

    export class ProductsToManufacturersStrategy implements ICollectionPopulate {
        constructor(private manufacturers: ICollectionBase<DP005ProductManufecturer>,
                    private products: ICollectionBase<IReportDP005Product>) {
        }

        populate(): void {
            if (this.products.models.length === 0) {
                return;
            }

            for (const manufacturer of this.manufacturers.models) {
                (<ISmartMoverCategoryModel<DP005ProductCategory>>manufacturer).resetModels(
                    this.products.models.filter(product => {
                        return manufacturer.get('manufacturer_TId') === product.get('dP005ProductManufecturers')[0].manufacturer_TId;
                    })
                )
            }
        }
    }
}
